import type { AxiosResponse } from 'axios'

/** Ensures that actual array is returned.
 * @throws {Error} if the response data is not an array.
 * @param data - The Axios response object.
 * 
 * This was created because of errors like: d.find is not a function, when the response was successful but the data was not an array.
 */
export function returnArray<T extends any[]>(data: AxiosResponse<T, any>): T {
    if (!Array.isArray(data.data)) throw new Error('Invalid response data.')

    return data.data
}
